import { twMerge } from 'tailwind-merge';

/** Wrapper for tailwind classes. Used for linting & merging conflicting classnames. */
export function tw(...classNames: Parameters<typeof twMerge>): string {
  return twMerge(...classNames);
}
